






































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalAlasanBatalOrder from "@/components/modal/CardModalAlasanBatalOrder.vue";
import { userModule } from "@/store/modules/user";
import { storePenunjang } from "@/store/modules/penunjang";
import moment from "moment";

@Component({
  components: {
    CardModalAlasanBatalOrder
  }
})
export default class ListOrderPenunjang extends Vue {
  @Prop() dataOrder!: Array<object>;
  @Prop() type!: string;
  @Prop({ default: false }) readOnly!: boolean;
  tab = "buat-order";
  modalBatalOrder = false;
  idOrder = "";

  mounted() {}

  get stateuser() {
    return userModule.user;
  }

  get loadingOrder() {
    if (this.type === "lab") {
      return storePenunjang.loadingOrderLab;
    } else {
      return storePenunjang.loadingOrderRadiologi;
    }
  }

  buatOrder() {
    this.$emit("pageTab", this.tab);
  }

  ubahOrder(dt) {
    const data = {
      detail: dt,
      page: this.tab,
      type: this.type
    };
    this.$emit("editOrder", data);
  }

  batalOrder(value) {
    this.idOrder = value;
    this.modalBatalOrder = true;
  }

  alasanBatal(value) {
    this.$emit("alasanBatal", value);
  }

  getHumanDate(date) {
    return date ? moment(date, "DD-MM-YYYY").format("DD MMMM YYYY") : "";
  }
}
